import { Dialog } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import React, { memo, ReactNode, RefObject } from 'react';

import styles from './DrillxPopin.module.scss';

export interface DrillxPopinProps {
  open: boolean;
  onClose?: () => void;
  onEnter?: () => void;
  ariaLabelledby?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
  displayCloseIcon?: boolean;
  actionClass?: string;
  contentRef?: RefObject<HTMLDivElement>;
  disableBackdropClick?: boolean;
  isHideChildStyles?: boolean;
}

const DrillxPopin: React.FC<DrillxPopinProps> = ({
  open,
  onClose,
  onEnter,
  ariaLabelledby,
  maxWidth,
  title,
  children,
  actions,
  className,
  displayCloseIcon = true,
  actionClass,
  contentRef,
  isHideChildStyles = false,
  disableBackdropClick = false,
}) => {
  return (
    <Dialog
      TransitionProps={{ onEnter }}
      open={open}
      fullWidth
      disableBackdropClick={disableBackdropClick}
      maxWidth={maxWidth}
      onClose={onClose}
      aria-labelledby={ariaLabelledby ?? ''}
      classes={{ paper: clsx(styles.popin, className) }}
    >
      {displayCloseIcon && onClose && (
        <CloseIcon aria-label="close" onClick={onClose} className={styles.upperCloseButton} />
      )}
      <div ref={contentRef}>
        {title && <div className={styles.title}>{title}</div>}
        {children && <div className={isHideChildStyles ? '' : styles.content}>{children}</div>}
        {actions && <div className={clsx(styles.actions, actionClass)}>{actions}</div>}
      </div>
    </Dialog>
  );
};

export default memo(DrillxPopin);
